import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import SubTable from './TopBarMenusTable'
import TopBarMenusEdit from './TopBarMenusEdit'
import TopBarMenusAdd from './TopBarMenusAdd'
import Pagination from '../Pagination'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import OSelect from '../../components/reusable/OSelect'
function TopBarMenus () {
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const manager = user?.permission?.find(e => e.manager === 'menus_manager') ?? {}
  const [showModal, setShowModal] = useState(false)
  const [editShowModal, setEditShowModal] = useState(false)
  // const [viewShow, setViewShow] = useState(false)
  const [topMenus, setTopMenus] = useState([])
  const [parentList, setParentList] = useState([{ value: '', key: 'All Parents' }, { value: 'none', key: 'None' }])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    menuType: '',
    parentId: '',
    isReset: false,
    isFilter: false
  })

  const { category, startDate, endDate, searchKey, menuType, parentId, isFilter } = filterData
  const allTopMenus = async (data) => {
    try {
      const payload = {
        page,
        pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        keyword: searchKey?.trim(),
        menuType,
        parentId
      }

      const path = apiPath.ListTopMenus
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setTopMenus(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const handlePageClick = (event) => {
    const newPage = event.selected + 1
    setPage(newPage)
  }
  const handelEdit = (item) => {
    setItem(item)
    setEditShowModal(true)
  }
  const handleChangeData = e => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true })
    setPage(1)
  }
  const handleUserView = (item) => {
    setItem(item)
    // setViewShow(true)
  }

  useEffect(() => {
    const fetchParents = async () => {
      try {
        const result = await apiGet(apiPath.ListTopMenus, { pageSize: 1000 })
        if (result?.data?.success) {
          const formatted = result.data.results.docs.map(i => ({ value: i._id, key: i.name }))
          setParentList([{ value: '', key: 'All Parents' }, { value: 'none', key: 'None' }, ...formatted])
        }
      } catch (error) {
        console.error('Error fetching parent menus', error)
      }
    }
    fetchParents()
  }, [])

  useEffect(() => {
    allTopMenus()
  }, [page, sort, filterData])

  const menuTypeOptions = [
    { value: '', key: t('ALL_MENU_TYPES', 'All Menu Types') },
    { value: 'Customer', key: 'Customer' },
    { value: 'Agent', key: 'Agent' },
    { value: 'Company', key: 'Company' },
    { value: 'website', key: 'Website' },
  ]

  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <div className='border-b border-b-[#E3E3E3] flex flex-wrap items-end gap-3 px-4 py-3'>
              <div className='w-full md:w-60'>
                <label
                  htmlFor='default-search'
                  className='block mb-2 text-sm font-medium text-gray-900'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='relative'>
                  <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                    <svg
                      aria-hidden='true'
                      className='w-4 h-4 text-[#A5A5A5]'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      {!filterData?.searchKey && (
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                        />
                      )}
                    </svg>
                  </div>
                  <input
                    type='search'
                    id='default-search'
                    className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 outline-none'
                    placeholder={t('SEARCH_BY_KEYWORD')}
                    value={filterData?.searchKey}
                    onChange={e => handleChangeData(e)}
                  />
                </div>
              </div>

              <div className='w-full md:w-52'>
                <OSelect
                  inputLabel={t('MENU_TYPE')}
                  name='menuType'
                  register={{
                    name: 'menuType',
                    onChange: (e) => {
                      setFilterData({ ...filterData, menuType: e.target.value, isFilter: true })
                      setPage(1)
                    }
                  }}
                  errors={{}}
                  options={menuTypeOptions}
                  value={filterData?.menuType}
                  wrapperClassName='w-full'
                />
              </div>

              <div className='w-full md:w-52'>
                <OSelect
                  inputLabel={t('PARENT_MENU')}
                  name='parentId'
                  register={{
                    name: 'parentId',
                    onChange: (e) => {
                      setFilterData({ ...filterData, parentId: e.target.value, isFilter: true })
                      setPage(1)
                    }
                  }}
                  errors={{}}
                  options={parentList}
                  value={filterData?.parentId}
                  wrapperClassName='w-full'
                />
              </div>

              <div className='ml-auto'>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    title={t('ADD_TOP_MENU')}
                    type='button'
                    className='bg-[#8FC150] flex text-sm px-8 py-2.5 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] whitespace-nowrap'
                    onClick={() => setShowModal(true)}
                  >
                    + {t('ADD_TOP_MENU')}
                  </button>
                )}
              </div>
            </div>
            <SubTable
              topMenus={topMenus}
              handelEdit={handelEdit}
              allTopMenus={allTopMenus}
              handleUserView={handleUserView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (<Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} />)}

          </div>
        </div>
      </div>

      <>
        {
          showModal
            ? (
              <TopBarMenusAdd setShowModal={setShowModal} allTopMenus={allTopMenus} />)
            : null
        }
        {
          editShowModal && (
            <TopBarMenusEdit
              setEditShowModal={setEditShowModal}
              allTopMenus={allTopMenus}
              item={item}
            />)
        }
      </>
    </div>
  )
}

export default TopBarMenus
